import u, { useEffect as N, useState as x, useRef as B, useCallback as Le, useMemo as we } from "react";
import { Ellipse as Se, Rect as J, Group as ce, Image as ue, Stage as ke, Layer as de, Text as Pe } from "react-konva";
import "gifler";
import De from "konva";
import { styled as Y } from "styled-components";
import xe from "@rehooks/component-size";
const Ut = {
  FOLLOW_CAMERA: "FOLLOW_CAMERA",
  // follow the camera described by the navigation map
  OVER_VIEW: "OVER_VIEW",
  // zoom out to see the entire navigation map
  DEBUG: "DEBUG"
  // use a free floating camera
}, ne = {
  ELLIPSE: "ELLIPSE",
  RECTANGLE: "RECTANGLE",
  MEDIA: "MEDIA"
}, He = /* @__PURE__ */ new Set([
  "mp4",
  "ogg",
  "webm",
  "3gp",
  "3g2",
  "m4v",
  "mov",
  "m4a"
]), X = {
  WIDTH: 1920,
  HEIGHT: 1080
}, ee = 1e3, H = {
  BORDER: "blue",
  HEALTH: "red",
  BACKGROUND: "black",
  HEIGHT: 25
}, j = {
  TOP: "TOP",
  BOTTOM: "BOTTOM",
  LEFT: "LEFT",
  RIGHT: "RIGHT",
  SCREEN: "SCREEN",
  HIDDEN: "HIDDEN"
}, fe = {
  [j.TOP]: (e) => ({
    ...e,
    y: e.y - H.HEIGHT,
    height: H.HEIGHT
  }),
  [j.BOTTOM]: (e) => ({
    ...e,
    y: e.y + e.height,
    height: H.HEIGHT
  }),
  [j.LEFT]: (e) => ({
    ...e,
    x: e.x - H.HEIGHT,
    width: H.HEIGHT
  }),
  [j.RIGHT]: (e) => ({
    ...e,
    x: e.x + e.width,
    width: H.HEIGHT
  })
}, Ne = {
  [j.RIGHT]: !0,
  [j.LEFT]: !0
}, F = {
  COLOR: "lightgreen",
  STROKE: "darkgreen",
  STROKE_WIDTH: 3,
  TEXT_HEIGHT: 15,
  LINE_HEIGHT: 17,
  OFFSET_X: 10,
  OFFSET_Y: 10
}, _e = ee * 0.2, $e = 5, Fe = 5, be = 250;
function ge(e) {
  return be * 2 ** e;
}
const M = {}, Te = /* @__PURE__ */ new Set(), te = {
  isPaused: !1
};
function Ge(e) {
  var t;
  return e ? (t = M[e]) == null ? void 0 : t.video : null;
}
function Ue() {
  let e = 0;
  const t = Object.keys(M);
  for (let n = 0; n < t.length; n++) {
    const { video: o } = M[t[n]];
    !o.paused && o.readyState > 2 && e++;
  }
  return e;
}
function Ve() {
  return Object.keys(M).length;
}
function Be() {
  te.isPaused = !0;
  const e = Object.keys(M);
  for (let t = 0; t < e.length; t++)
    M[e[t]].video.pause();
}
function We() {
  te.isPaused = !1;
  const e = Object.keys(M);
  for (let t = 0; t < e.length; t++) {
    const n = M[e[t]];
    n.refCount > 0 && n.play();
  }
}
function ye(e) {
  if (!e || M[e])
    return;
  const t = Xe(e);
  if (!t)
    return;
  let n = 0;
  const o = () => {
    var a, s;
    if (console.error(
      `VIDEO: Error '${String((a = t.error) == null ? void 0 : a.code)}' details: '${String(
        (s = t.error) == null ? void 0 : s.message
      )}' for source '${String(e)}' `
    ), !!M[e]) {
      if (n >= Fe) {
        console.error("VIDEO: " + e + " failed to load and is out of retries");
        return;
      }
      Te.add(
        setTimeout(() => {
          M[e] && (t.src = "", t.src = e);
        }, ge(n++))
      );
    }
  }, i = () => {
    t.play().catch((a) => console.error(a));
  }, r = () => {
    M[e] && M[e].refCount > 0 && !te.isPaused && i();
  };
  t.onerror = o, t.oncanplay = r, M[e] = {
    refCount: 0,
    video: t,
    play: i,
    onCanPlay: r,
    onError: o
  };
}
function Ye() {
  Object.keys(M).forEach((e) => {
    const { video: t, onCanPlay: n, onError: o } = M[e];
    t && (t.pause(), t.removeEventListener("canplay", n), t.removeEventListener("error", o)), delete M[e];
  }), Array.from(Te).map(clearTimeout);
}
function Ke(e) {
  if (!e)
    return;
  M[e] || ye(e);
  const t = M[e];
  if (!M[e])
    return;
  t.refCount += 1;
  const n = t.video;
  return n.paused && n.readyState > 2 && !te.isPaused && t.play(), M[e].video;
}
function qe(e) {
  if (!e)
    return;
  const t = M[e];
  t && (t.refCount -= 1, t.refCount <= 0 && t.video.pause());
}
function Xe(e) {
  if (!e)
    return null;
  const t = document.createElement("video");
  return t.loop = !0, t.muted = !0, t.src = e, t;
}
const L = {}, Oe = /* @__PURE__ */ new Set();
function je(e) {
  var t;
  return e ? (t = L[e]) == null ? void 0 : t.image : null;
}
function Je() {
  return Object.keys(L).length;
}
function Ce(e) {
  if (!e || L[e])
    return;
  const t = document.createElement("img"), n = () => {
    L[e] && (L[e].status = "loaded");
  };
  let o = 0;
  const i = () => {
    if (console.error("IMAGE: " + e + " failed to load"), !!L[e]) {
      if (L[e].status = "failed", o >= $e) {
        console.error("IMAGE: " + e + " failed to load and is out of retries");
        return;
      }
      Oe.add(
        setTimeout(() => {
          L[e] && (t.src = "", t.src = e);
        }, ge(o++))
      );
    }
  };
  t.addEventListener("load", n), t.addEventListener("error", i), t.src = e, L[e] = {
    refCount: 0,
    image: t,
    status: "loading",
    onLoad: n,
    onError: i
  };
}
function Qe() {
  Object.keys(L).forEach((e) => {
    const t = L[e], n = t.image;
    n && (n.removeEventListener("load", t.onLoad), n.removeEventListener("error", t.onError)), delete L[e];
  }), Array.from(Oe).map(clearTimeout);
}
function Ze(e) {
  if (!(!e || (L[e] || Ce(e), !L[e])))
    return L[e].refCount += 1, L[e].image;
}
function ze(e) {
  if (!e)
    return;
  const t = L[e];
  t && (t.refCount -= 1);
}
function Ae(e) {
  return e.endsWith(".gif");
}
function Me(e) {
  let t = e.split(".");
  return He.has(t[t.length - 1]);
}
function b(e) {
  return e * 180 / Math.PI;
}
function ve(e, t) {
  let n = !1, o = 1 / 0, i = -1 / 0, r = 1 / 0, a = -1 / 0;
  for (let s of e) {
    const l = t[s];
    if (!l)
      continue;
    n = !0;
    const m = l.position.r;
    let d = Math.sqrt(
      (l.width * Math.cos(m)) ** 2 + (l.height * Math.sin(m)) ** 2
    ), p = Math.sqrt(
      (l.width * Math.sin(m)) ** 2 + (l.height * Math.cos(m)) ** 2
    );
    o = Math.min(l.position.x - d / 2, o), i = Math.max(l.position.x + d / 2, i), r = Math.min(l.position.y - p / 2, r), a = Math.max(l.position.y + p / 2, a);
  }
  return n ? {
    x: o,
    y: r,
    width: i - o,
    height: a - r
  } : null;
}
function et(e, t, n, o, i, r, a) {
  const s = { ...e.position };
  if (e.parent && (!t[e.parent] || !n[e.parent]))
    return null;
  const l = Ie(
    e,
    i,
    o,
    t,
    r
  );
  if (l !== void 0)
    return l;
  if (e.parent && t[e.parent]) {
    const m = t[e.parent], d = n[e.parent], p = Math.sqrt(
      (e.position.x - d.position.x) ** 2 + (e.position.y - d.position.y) ** 2
    ), f = Math.atan2(
      e.position.y - d.position.y,
      e.position.x - d.position.x
    ), T = m.position.r - d.position.r;
    s.x = Math.cos(T + f) * p + m.position.x, s.y = Math.sin(T + f) * p + m.position.y, s.r = m.position.r;
  } else
    s.x = e.position.x + e.velocity.x * a, s.y = e.position.y + e.velocity.y * a, s.r = e.position.r + e.velocity.r * a;
  return {
    ...e,
    position: s
  };
}
function tt(e, t, n, o) {
  const i = n[e.id];
  return e.health == null || !i || i.health == null ? e : {
    ...e,
    health: e.health + (i.health - e.health) * o
  };
}
function nt(e, t, n, o, i, r, a, s, l, m) {
  const d = { ...e.position };
  if (e.parent && (!r[e.parent] || !n[e.parent]) || !s[e.id])
    return null;
  const p = Ie(
    e,
    t,
    a,
    r,
    i
  );
  if (p !== void 0)
    return p;
  if (e.parent && r[e.parent]) {
    const f = r[e.parent], T = n[e.parent], I = Math.sqrt(
      (e.position.x - T.position.x) ** 2 + (e.position.y - T.position.y) ** 2
    ), c = Math.atan2(
      e.position.y - T.position.y,
      e.position.x - T.position.x
    );
    d.x = Math.cos(f.position.r - T.position.r + c) * I + f.position.x, d.y = Math.sin(f.position.r - T.position.r + c) * I + f.position.y, d.r = f.position.r;
  } else {
    const f = s[e.id];
    d.x = e.position.x + (f.position.x - e.position.x) * m, d.y = e.position.y + (f.position.y - e.position.y) * m, d.r = e.position.r + (f.position.r - e.position.r) * m;
  }
  return {
    ...e,
    position: d
  };
}
function oe(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function me(e, t) {
  const n = t[e.id];
  return n ? {
    x: e.position.x - n.position.x,
    y: e.position.y - n.position.y
  } : null;
}
function Ie(e, t, n, o, i) {
  const r = n[e.id];
  if (r && r.controlled)
    for (let a = 0; a < r.controlled.length; a++)
      switch (r.controlled[a].controlKey) {
        case "CAMERA_DISPLACEMENT":
          return ot(
            e,
            r.controlled[a].params,
            n,
            t,
            i
          );
        case "FOLLOW":
          return it(
            e,
            r.controlled[a].params,
            o
          );
      }
}
function ot(e, t, n, o, i) {
  if (!i)
    return null;
  const r = o[e.id];
  return r ? {
    ...e,
    position: {
      ...e.position,
      x: r.position.x + i.x * t,
      y: r.position.y + i.y * t
    }
  } : (console.error(
    `can not control an object through CAMERA_DISPLACEMENT if object is not defined in the original model  (modelId ${e.id})`
  ), null);
}
function it(e, t, n) {
  const o = n[t];
  return o ? {
    ...e,
    position: {
      ...e.position,
      x: o.position.x,
      y: o.position.y
    }
  } : null;
}
function rt(e, t, n, o, i) {
  const r = Object.keys(e);
  for (let a = 0; a < r.length; a++) {
    const {
      position: { r: s, y: l, x: m },
      width: d,
      height: p
    } = e[r[a]], f = Math.sqrt(
      (d * Math.cos(s)) ** 2 + (p * Math.sin(s)) ** 2
    ), T = Math.sqrt(
      (d * Math.sin(s)) ** 2 + (p * Math.cos(s)) ** 2
    );
    st(
      t,
      n,
      o,
      i,
      l - T / 2,
      m - f / 2,
      l + T / 2,
      m + f / 2
    ) || delete e[r[a]];
  }
}
function at(e, t) {
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    if (!o.url)
      continue;
    const i = t(o.url);
    if (Me(i)) {
      ye(i);
      continue;
    }
    Ae(i) || Ce(i);
  }
}
function st(e, t, n, o, i, r, a, s) {
  return !(t > s || r > o || e > a || i > n);
}
function lt(e, t, n, o, i) {
  const r = Object.keys(e);
  for (let a = 0; a < r.length; a++) {
    let s = r[a];
    const l = e[s];
    let m = !0;
    t.has(l.id) && (m = n && o), l.isCollision && (m = n && i), m || delete e[s];
  }
}
function ie(e, t, n = 10) {
  const o = 10 ** t;
  return Math.round(e * o) / o;
}
function z(e) {
  return e == null ? e : (e = Math.floor(e), e < 1e3 ? `${e} B` : (e = e / 1e3, e < 1e3 ? `${ie(e, 2)} KB` : (e = e / 1e3, e < 1e3 ? `${ie(e, 2)} MB` : (e = e / 1e3, `${ie(e, 2)} GB`))));
}
function he(e, t, n, o, i) {
  let r = e, a = t;
  if (i && o) {
    a = i;
    const c = /* @__PURE__ */ new Set();
    for (let C = 0; C < e.length; C++)
      c.add(e[C].id);
    r = o.filter(
      (C) => c.has(C.id)
    );
  }
  const s = {}, l = {}, m = (c) => {
    l[c] = { parents: /* @__PURE__ */ new Set(), children: {} }, s[c] = l[c];
  }, d = (c, C) => {
    s[c] && delete s[c], l[C] || m(C), l[c].parents.add(C), l[C].children[c] = l[c];
  };
  for (let c = 0; c < r.length; c++) {
    const C = r[c];
    if (l[C.id] || m(C.id), C.parent) {
      d(C.id, C.parent);
      continue;
    }
    const R = a[C.id];
    if (!R) {
      console.error(
        `Encountered a model ${C.id} which does not belong to an entity`
      );
      continue;
    }
    const _ = R.controlled;
    if (_)
      for (let S = 0; S < _.length; S++) {
        const P = _[S];
        switch (P.controlKey) {
          case "CAMERA_DISPLACEMENT": {
            d(C.id, n);
            break;
          }
          case "FOLLOW": {
            d(C.id, P.params);
            break;
          }
        }
      }
  }
  const p = [], f = /* @__PURE__ */ new Set();
  let T = Object.keys(s);
  for (let c = 0; c < T.length; c++)
    Re(T[c], null, p, f, l);
  const I = Object.keys(l);
  return I.length && console.error(
    `[NAVIGATION] positioning error: could not determine the positioning order for ${I.length} models: ${JSON.stringify(I)}`
  ), p;
}
function Re(e, t, n, o, i) {
  if (o.has(e)) {
    console.error(
      `[NAVIGATION] positioning error: model ${e} has already been positioned but is trying to position again. The positioning graph must be acyclic.`
    );
    return;
  }
  const r = i[e];
  if (!r) {
    console.error(
      `[NAVIGATION] positioning error: model ${e} does not have a node in the positioning graph.`
    );
    return;
  }
  if (t && r.parents.delete(t), r.parents.size)
    return;
  o.add(e), n.push(e), delete i[e];
  const a = Object.keys(r.children);
  for (let s = 0; s < a.length; s++)
    Re(
      a[s],
      e,
      n,
      o,
      i
    );
}
function ct({
  x: e,
  y: t,
  r: n,
  width: o,
  height: i,
  fill: r,
  stroke: a,
  onClick: s
}) {
  return /* @__PURE__ */ u.createElement(
    Se,
    {
      x: e,
      y: t,
      rotation: b(n),
      width: o,
      height: i,
      fill: r,
      stroke: a,
      onClick: s
    }
  );
}
function ut({
  x: e,
  y: t,
  r: n,
  width: o,
  height: i,
  fill: r,
  stroke: a,
  onClick: s
}) {
  return e = Math.cos(n) * (-o / 2) - Math.sin(n) * (-i / 2) + e, t = Math.sin(n) * (-o / 2) + Math.cos(n) * (-i / 2) + t, /* @__PURE__ */ u.createElement(
    J,
    {
      x: e,
      y: t,
      rotation: b(n),
      width: o,
      height: i,
      fill: r,
      stroke: a,
      onClick: s
    }
  );
}
const dt = 5 * ee;
function ft(e) {
  return N(() => (Ze(e), () => ze(e)), [e]), je(e);
}
function mt(e) {
  return N(() => (Ke(e), () => qe(e)), [e]), Ge(e);
}
function ht(e, t, n) {
  const o = Date.now(), [i, r] = x(null), a = B(), s = B(!1), [l, m] = x(null), [d, p] = x([]), [f, T] = x([]), I = Date.now(), c = B({
    lastReportTime: I,
    metrics: {
      stallTime: 0,
      predictionTime: 0,
      interpolationTime: 0
    }
  }), C = B(I), R = I - C.current;
  C.current = I, N(() => {
    s.current = !1, r(null), T([]), m(e.instanceId);
  }, [e.instanceId]), N(() => {
    if (i === null && f.length === 1) {
      const g = Date.now();
      r({
        serverTime: f[0].serverTime - _e,
        localTime: g
      }), T((A) => {
        if (A.length < 2)
          return A;
        let [O, ...v] = A;
        O = { ...O };
        const k = e.updateTime - O.serverTime;
        return O.adjustedLocalTime = g - k, [O, ...v];
      }), s.current = !0;
    }
    let h = {}, E = {}, y = {};
    e.entityData.forEach((g) => {
      h[g.id] = g;
    }), e.models.forEach((g) => {
      E[g.id] = g;
    }), e.originalModels.forEach((g) => {
      y[g.id] = g;
    }), T((g) => {
      const A = Date.now(), O = g[g.length - 1], v = {
        serverTime: e.updateTime,
        adjustedLocalTime: i ? i.localTime + (e.updateTime - i.serverTime) : Date.now(),
        modelLookup: E,
        entityLookup: h,
        originalModelLookup: y,
        isPaused: e.isPaused,
        stats: e.stats,
        camera: e.camera,
        interpolationPositionOrdering: O ? he(
          e.models,
          h,
          O.camera,
          Object.values(O.modelLookup),
          O.entityLookup
        ) : null,
        positionOrdering: he(
          e.models,
          h,
          e.camera
        ),
        frameCalculationTime: 0
      }, k = [...g, v];
      return v.frameCalculationTime = Date.now() - A, k;
    }), at(e.models, t);
  }, [e.updateTime]);
  const _ = Le((h) => {
    p((E) => {
      const y = Date.now(), g = y - ee, A = [...E, y];
      for (; A[0] && A[0] < g; )
        A.shift();
      return A;
    }), T((E) => {
      if (!s.current)
        return E;
      const y = Date.now(), g = [];
      let A = -1;
      for (let O = 0; O < E.length && E[O].adjustedLocalTime <= y; O++)
        A = O - 1;
      for (let O = A + 1; O < E.length; O++)
        g.push(E[O]);
      return g;
    });
  }, []);
  if (N(() => {
    const h = (E) => {
      a.current = requestAnimationFrame(h), _(E);
    };
    return a.current = requestAnimationFrame(h), () => {
      a.current && cancelAnimationFrame(a.current);
    };
  }, [_]), !s.current || !i || l !== e.instanceId)
    return null;
  let S = {}, P = {}, Q = !1, $ = [], D = {}, w = "Broken", G = null, K = null, U = {
    totalModels: -1,
    totalOriginalModels: -1,
    totalEntities: -1
  }, q = null, V = -1;
  if (f.length > 0 && f[0].isPaused && (f.length === 1 || f[1].isPaused)) {
    c.current.metrics.stallTime += R;
    const h = f[0];
    w = "static (Paused)", Q = !0, S = { ...h.modelLookup }, P = { ...h.entityLookup }, D = h.originalModelLookup, U = h.stats, V = h.frameCalculationTime;
    const E = h.modelLookup;
    $ = Object.keys(h.modelLookup).sort(
      (y, g) => E[y].layer - E[g].layer
    ), h.camera && (K = S[h.camera]), q = h.serverTime - Date.now();
  } else if (f.length === 1) {
    c.current.metrics.predictionTime += R, w = "Prediction";
    const h = f[0];
    U = h.stats, V = h.frameCalculationTime, P = h.entityLookup, D = h.originalModelLookup;
    const E = h.modelLookup;
    $ = Object.keys(E).sort(
      (A, O) => E[A].layer - E[O].layer
    );
    const y = (Date.now() - h.adjustedLocalTime) / ee, g = h.positionOrdering;
    for (let A = 0; A < g.length; A++) {
      const O = g[A], v = et(
        h.modelLookup[O],
        S,
        h.modelLookup,
        P,
        D,
        G,
        y
      );
      if (!v) {
        console.error(`[NAVIGATION] unable to position model ${O}`);
        continue;
      }
      O === h.camera && (G = me(
        v,
        D
      ), K = v), S[v.id] = v;
    }
    q = h.serverTime - Date.now();
  } else if (f.length > 1 && f[1].interpolationPositionOrdering) {
    c.current.metrics.interpolationTime += R, w = "interpolation";
    const h = f[1].interpolationPositionOrdering, E = f[0];
    U = E.stats, V = E.frameCalculationTime;
    const y = E.modelLookup;
    $ = Object.keys(E.modelLookup).sort(
      (v, k) => y[v].layer - y[k].layer
    ), D = E.originalModelLookup;
    const g = f[1], A = Object.values(
      E.entityLookup
    ), O = (Date.now() - E.adjustedLocalTime) / (g.adjustedLocalTime - E.adjustedLocalTime || 1);
    q = E.serverTime + (g.serverTime - E.serverTime) * O - Date.now();
    for (let v = 0; v < A.length; v++) {
      const k = tt(
        A[v],
        E.entityLookup,
        g.entityLookup,
        O
      );
      k && (P[k.id] = k);
    }
    for (let v = 0; v < h.length; v++) {
      const k = h[v], Z = nt(
        y[k],
        D,
        y,
        E.entityLookup,
        G,
        S,
        P,
        g.modelLookup,
        g.entityLookup,
        O
      );
      if (!Z) {
        console.error(`[NAVIGATION] unable to position model ${k}`);
        continue;
      }
      k === E.camera && (G = me(
        Z,
        D
      ), K = Z), S[Z.id] = Z;
    }
  } else
    return console.error(
      "There are no frames to predict or interpolate from (or next frame does not have an 'interpolationPositionOrdering'), something has gone horribly wrong"
    ), null;
  if (c.current.lastReportTime + dt < I) {
    const h = c.current.metrics;
    n == null || n([
      {
        metric: "navigationMapPerformance.frameRate",
        value: d.length
      },
      {
        metric: "navigationMapPerformance.stallTime",
        value: h.stallTime
      },
      {
        metric: "navigationMapPerformance.predictionTime",
        value: h.predictionTime
      },
      {
        metric: "navigationMapPerformance.interpolationTime",
        value: h.interpolationTime
      }
    ]), c.current = {
      lastReportTime: I,
      metrics: {
        interpolationTime: 0,
        predictionTime: 0,
        stallTime: 0
      }
    };
  }
  return {
    models: S,
    entities: P,
    strategy: w,
    fps: d.length,
    storedFrames: f.length,
    order: $,
    isPaused: Q,
    stats: U,
    originalModels: D,
    cameraDisplacement: G,
    camera: K,
    expectedTimeDisplacement: i != null ? i.serverTime - i.localTime : null,
    currentTimeDisplacement: q,
    positioningElapseTime: Date.now() - o,
    frameCalculationTime: V
  };
}
function pt({
  url: e,
  x: t,
  y: n,
  width: o,
  height: i,
  r,
  stroke: a,
  onClick: s
}) {
  const l = ft(e);
  return t = Math.cos(r) * (-o / 2) - Math.sin(r) * (-i / 2) + t, n = Math.sin(r) * (-o / 2) + Math.cos(r) * (-i / 2) + n, /* @__PURE__ */ u.createElement(ce, { x: t, y: n, width: o, height: i }, a ? /* @__PURE__ */ u.createElement(
    J,
    {
      x: 0,
      y: 0,
      width: o,
      height: i,
      stroke: a,
      rotation: b(r)
    }
  ) : null, /* @__PURE__ */ u.createElement(
    ue,
    {
      x: 0,
      y: 0,
      width: o,
      height: i,
      rotation: b(r),
      image: l != null && l.complete ? l : null,
      onClick: s
    }
  ));
}
function Et({
  url: e,
  x: t,
  y: n,
  r: o,
  width: i,
  height: r,
  stroke: a,
  onClick: s
}) {
  const l = B(null), m = we(() => document.createElement("canvas"), []);
  return N(() => {
    if (!e || !l)
      return;
    let d;
    try {
      window.gifler(e).get((p) => {
        d = p, d.animateInCanvas(m), d.onDrawFrame = (f, T) => {
          f.drawImage(T.buffer, T.x, T.y), l.current && l.current.getLayer().draw();
        };
      });
    } catch (p) {
      console.error("error while trying to load gif", p);
    }
    return () => {
      if (d)
        try {
          d.stop();
        } catch (p) {
          console.error("error while trying to stop gif", p);
        }
    };
  }, [e, m]), t = Math.cos(o) * (-i / 2) - Math.sin(o) * (-r / 2) + t, n = Math.sin(o) * (-i / 2) + Math.cos(o) * (-r / 2) + n, /* @__PURE__ */ u.createElement(ce, { x: t, y: n, width: i, height: r }, a ? /* @__PURE__ */ u.createElement(
    J,
    {
      x: 0,
      y: 0,
      width: i,
      height: r,
      stroke: a,
      rotation: b(o)
    }
  ) : null, /* @__PURE__ */ u.createElement(
    ue,
    {
      image: m,
      ref: l,
      x: 0,
      y: 0,
      width: i,
      height: r,
      rotation: b(o),
      onClick: s
    }
  ));
}
function gt({
  url: e,
  x: t,
  y: n,
  r: o,
  width: i,
  height: r,
  stroke: a,
  onClick: s
}) {
  const l = B(), m = mt(e), d = l.current;
  return N(() => {
    if (!l.current)
      return;
    const p = new De.Animation(() => {
    }, l.current.getLayer());
    return p.start(), () => {
      p.stop();
    };
  }, [l, d]), t = Math.cos(o) * (-i / 2) - Math.sin(o) * (-r / 2) + t, n = Math.sin(o) * (-i / 2) + Math.cos(o) * (-r / 2) + n, /* @__PURE__ */ u.createElement(ce, { x: t, y: n, width: i, height: r }, a ? /* @__PURE__ */ u.createElement(
    J,
    {
      x: 0,
      y: 0,
      width: i,
      height: r,
      stroke: a,
      rotation: b(o)
    }
  ) : null, /* @__PURE__ */ u.createElement(
    ue,
    {
      x: 0,
      y: 0,
      rotation: b(o),
      width: i,
      height: r,
      image: m,
      ref: l,
      onClick: s
    }
  ));
}
function Tt({
  component: e,
  onClick: t,
  isSelectable: n,
  urlResolver: o
}) {
  const i = {
    ...e.position
  };
  if (n && (i.onClick = () => t(e)), e.type === ne.MEDIA) {
    const r = {
      ...i,
      stroke: e.stroke,
      width: e.width,
      height: e.height,
      url: o(e.url)
    };
    return Ae(e.url) ? /* @__PURE__ */ u.createElement(Et, { ...r }) : Me(e.url) ? /* @__PURE__ */ u.createElement(gt, { ...r }) : /* @__PURE__ */ u.createElement(pt, { ...r });
  }
  return e.type === ne.ELLIPSE ? /* @__PURE__ */ u.createElement(
    ct,
    {
      ...i,
      stroke: e.stroke,
      fill: e.color,
      height: e.height,
      width: e.width
    }
  ) : e.type === ne.RECTANGLE ? /* @__PURE__ */ u.createElement(
    ut,
    {
      ...i,
      stroke: e.stroke,
      fill: e.color,
      height: e.height,
      width: e.width
    }
  ) : null;
}
function yt({
  x: e,
  y: t,
  width: n,
  height: o,
  percentage: i,
  isVertical: r
}) {
  const [a] = x(n), [s] = x(o), l = r ? (o - s) / 2 : (n - a) / 2, m = r ? t + l : t, d = r ? e : e + l;
  return /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement(
    J,
    {
      x: d,
      y: m,
      width: a,
      height: s,
      fill: H.BACKGROUND,
      stroke: H.BORDER
    }
  ), /* @__PURE__ */ u.createElement(
    J,
    {
      x: d,
      y: r ? m + s * oe(1 - i, 0, 1) : t,
      width: r ? a : a * oe(i, 0, 1),
      height: r ? s * oe(i, 0, 1) : s,
      fill: H.HEALTH
    }
  ));
}
function Ot({
  entityLookup: e,
  modelLookup: t
}) {
  let n = [];
  return Object.keys(e).forEach((o) => {
    const i = e[o], r = i.healthLocation, a = i.health, s = i.originalHealth;
    if (r && a != null && s) {
      const l = ve(i.components, t);
      if (l && fe[r]) {
        const m = fe[r](l);
        n.push(
          /* @__PURE__ */ u.createElement(
            yt,
            {
              key: i.id,
              ...m,
              isVertical: Ne[r] || !1,
              percentage: s && a / s
            }
          )
        );
      }
    }
  }), n;
}
function Ct({
  isDebugging: e,
  showCollisions: t,
  showCamera: n,
  clientState: o,
  setSelected: i,
  isOverview: r,
  urlResolver: a,
  parent: s,
  isInteractable: l,
  onReportMetrics: m
}) {
  let d = 0, p = 0, f = X.WIDTH, T = X.HEIGHT, I = 1;
  const c = ht(
    o,
    a,
    m
  );
  if (N(() => {
    c != null && c.isPaused ? Be() : We();
  }, [c == null ? void 0 : c.isPaused]), N(() => () => {
    Qe(), Ye();
  }, [o == null ? void 0 : o.instanceId]), !c)
    return /* @__PURE__ */ u.createElement(Mt, null, /* @__PURE__ */ u.createElement("h1", null, "Connecting to Robot"));
  const {
    entities: C,
    models: R,
    fps: _,
    strategy: S,
    storedFrames: P,
    order: Q
  } = c, $ = Object.keys(R).length, D = Object.keys(C).length, { camera: w } = c;
  w && (C[w.id] ? (d = w.position.x - w.width / 2, p = w.position.y - w.height / 2, f = w.width, T = w.height) : console.error(`Camera entity ${w.id} was not found`));
  const G = new Set(w ? [w.id] : []), K = { ...R };
  lt(
    R,
    G,
    e,
    n,
    t
  );
  const U = $ - Object.keys(R).length;
  if (r) {
    const y = ve(Object.keys(R), R);
    d = y ? y.x : 0, p = y ? y.y : 0, f = y ? y.width : X.WIDTH, T = y ? y.height : X.HEIGHT, I = Math.min(
      X.WIDTH / f,
      X.HEIGHT / T
    ), f = Math.ceil(f * I), T = Math.ceil(T * I);
  }
  rt(
    R,
    p,
    d,
    p + T,
    d + f
  );
  const q = $ - U - Object.keys(R).length;
  let V = "width-based";
  T / f > s.height / s.width && (V = "height-based");
  const h = [];
  for (let y = 0; y < Q.length; y++) {
    const g = R[Q[y]];
    g && h.push(
      /* @__PURE__ */ u.createElement(
        Tt,
        {
          component: g,
          key: g.id,
          onClick: (A) => i(A),
          isSelectable: e,
          urlResolver: a
        }
      )
    );
  }
  const E = e ? [
    `FPS: ${_}`,
    `Lag Frames: ${P}`,
    `Strategy: ${S}`,
    `Rendered Objects: ${Object.keys(R).length} (world: ${c.stats.totalModels}, total received: ${$}, invisible: ${U}, culled: ${q})`,
    `Images Cached: ${Je()}`,
    `Videos Cached: ${Ve()}`,
    `Videos Playing: ${Ue()}`,
    `Interpreted Entities: ${D} (world: ${c.stats.totalEntities})`,
    `Obtained Original Models: ${Object.keys(c.originalModels).length} (world: ${c.stats.totalOriginalModels})`,
    `Camera Displacement: ${c.cameraDisplacement ? `x: ${c.cameraDisplacement.x}, y: ${c.cameraDisplacement.y}` : "null"}`,
    `Update Size: ${z(c.stats.updateSize) ?? "N/A"} (max: ${z(c.stats.maxUpdateSize) ?? "N/A"}, mean: ${z(c.stats.averageUpdateSize) ?? "N/A"}, min: ${z(c.stats.minUpdateSize) ?? "N/A"}, count: ${c.stats.updateCount ?? "N/A"}, total size: ${z(c.stats.totalUpdateSize) ?? "N/A"})`,
    `Paused: ${String(c.isPaused)}`,
    `Server Tick Length: ${String(c.stats.serverTickLength)}`,
    `Positioning Time: ${String(c.positioningElapseTime)}`,
    `Frame Calculation Time: ${String(c.frameCalculationTime)}`,
    `Expected Time Displacement: ${String(
      c.expectedTimeDisplacement
    )}`,
    `Current Time Displacement: ${String(
      c.currentTimeDisplacement
    )}`
  ] : [];
  return /* @__PURE__ */ u.createElement(
    At,
    {
      width: f,
      height: T,
      scaleX: I,
      scaleY: I,
      className: V,
      listening: l
    },
    /* @__PURE__ */ u.createElement(de, { offsetX: d, offsetY: p }, h, /* @__PURE__ */ u.createElement(
      Ot,
      {
        entityLookup: C,
        modelLookup: K
      }
    )),
    e ? /* @__PURE__ */ u.createElement(de, null, /* @__PURE__ */ u.createElement(
      Pe,
      {
        text: E.join(`
`),
        fill: F.COLOR,
        y: (T - E.length * F.LINE_HEIGHT - F.OFFSET_Y) / 2,
        x: f * 2 / 3,
        fontSize: F.TEXT_HEIGHT,
        stroke: F.STROKE,
        strokeWidth: F.STROKE_WIDTH,
        lineHeight: F.LINE_HEIGHT / F.TEXT_HEIGHT,
        fillAfterStrokeEnabled: !0,
        perfectDrawEnabled: !1,
        shadowForStrokeEnabled: !1
      }
    )) : null
  );
}
const At = Y(ke)`
	width: 100%;
	height: 100%;

	&.width-based {
		& > .konvajs-content {
			width: 100% !important;
			height: auto !important;

			& > canvas {
				width: 100% !important;
				height: auto !important;
			}
		}
	}

	&.height-based {
		& > .konvajs-content {
			width: auto !important;
			height: 100% !important;

			& > canvas {
				width: auto !important;
				height: 100% !important;
			}
		}
	}
`, Mt = Y.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	color: white;
`;
function se({ toRender: e }) {
  return e && typeof e == "object" ? /* @__PURE__ */ u.createElement("div", null, /* @__PURE__ */ u.createElement(vt, { toRender: e })) : typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? /* @__PURE__ */ u.createElement("div", null, /* @__PURE__ */ u.createElement(It, { toRender: e })) : /* @__PURE__ */ u.createElement("div", null, /* @__PURE__ */ u.createElement(Rt, null, "Unable To Render Property of type ", `"${typeof e}"`, " "));
}
function vt({ toRender: e }) {
  return Array.isArray(e) ? e.map((t, n) => /* @__PURE__ */ u.createElement("div", { key: n }, /* @__PURE__ */ u.createElement(le, null, n), /* @__PURE__ */ u.createElement(pe, null, /* @__PURE__ */ u.createElement(se, { toRender: t })))) : Object.keys(e).map((t) => /* @__PURE__ */ u.createElement("div", { key: t }, /* @__PURE__ */ u.createElement(le, null, t), /* @__PURE__ */ u.createElement(pe, null, /* @__PURE__ */ u.createElement(se, { toRender: e[t] }))));
}
function It({ toRender: e }) {
  return /* @__PURE__ */ u.createElement(le, null, String(e));
}
const le = Y.a`
	color: gray;
`, Rt = Y.a`
	color: red;
`, pe = Y.div`
	padding-left: 16px;
`;
function Lt({
  data: e,
  showCollisions: t,
  setShowCollisions: n,
  showCamera: o,
  setShowCamera: i
}) {
  const [r, a] = x(!1);
  return /* @__PURE__ */ u.createElement(wt, null, /* @__PURE__ */ u.createElement("h4", { onClick: () => a(!r) }, "Debug"), r ? /* @__PURE__ */ u.createElement(se, { toRender: e }) : null, /* @__PURE__ */ u.createElement("label", null, "Show Collisions", /* @__PURE__ */ u.createElement(
    "input",
    {
      type: "checkbox",
      value: t,
      checked: t,
      onChange: (s) => n(s.target.checked)
    }
  )), /* @__PURE__ */ u.createElement("label", null, "Show Camera", /* @__PURE__ */ u.createElement(
    "input",
    {
      type: "checkbox",
      value: o,
      checked: o,
      onChange: (s) => i(s.target.checked)
    }
  )));
}
const wt = Y.div`
	display: flex;
`, W = {
  IS_PAUSED: {
    TRUE: 1,
    FALSE: 0
  },
  ARRAY: {
    NO_UPDATE: 9
  },
  ARRAY_ELEMENT: {
    PATCH: 0,
    REMOVE: 1
  },
  NUMBER: { NO_UPDATE: "" },
  STRUCTURE: {
    SET: 0,
    PATCH: 1
  }
};
function Vt(e, t) {
  let n = t;
  try {
    switch (n[0]) {
      case W.STRUCTURE.SET:
        return n = n, {
          ...n[1]
        };
      case W.STRUCTURE.PATCH:
        if (!e)
          throw new Error(
            "Can not update the navigation map using patch structure 1 because there is no current value"
          );
        return n = n, kt(n, e);
      default:
        throw new Error(
          `Navigation Update Parser does not know how to update with structure ${n[0]}`
        );
    }
  } catch (o) {
    throw console.error(
      `Error when updating the navigation map with custom patches
	patches`,
      t,
      `
	Error`,
      o
    ), o;
  }
}
function St(e, t = 0, n = 1) {
  return typeof e == "number" && (e === t || e === n);
}
function kt(e, t) {
  t.updateTime = t.updateTime + e[1];
  let n = 2;
  return St(
    e[n],
    W.IS_PAUSED.FALSE,
    W.IS_PAUSED.TRUE
  ) && (t.isPaused = !!e[n], n++), Array.isArray(e[n]) && re(
    e[n],
    t.models,
    Ee
  ), Array.isArray(e[++n]) && re(
    e[n],
    t.entityData,
    Dt
  ), Array.isArray(e[++n]) && re(
    e[n],
    t.originalModels,
    Ee
  ), t;
}
function re(e, t, n) {
  const o = e[0];
  for (let i = 1; i < e.length; i++) {
    const [r, a, ...s] = e[i];
    if (a === W.ARRAY_ELEMENT.REMOVE) {
      t.splice(r, 1);
      continue;
    }
    if (a === W.ARRAY_ELEMENT.PATCH) {
      t[r] = n(s, t[r]);
      continue;
    }
    console.error(`unknown array update code ${a}`);
  }
  t.length = o;
}
const ae = ["x", "y", "r"], Pt = ["position", "velocity", "acceleration"];
function Ee(e, t) {
  if (typeof e[0] != "number" && e[0] !== W.NUMBER.NO_UPDATE)
    return e[0];
  if (!t)
    throw new Error(
      `can not update a model using strategy ${String(
        e[0]
      )} when model does not exist`
    );
  e = e;
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    typeof o == "number" && (t[Pt[Math.floor(n / ae.length)]][ae[n % ae.length]] = o);
  }
  return t;
}
function Dt(e, t) {
  if (typeof e[0] != "number")
    return e[0];
  if (!t)
    throw new Error(
      `can not update a entity using strategy ${e[0]} when entity does not exist`
    );
  return t.health = e[0], t;
}
function xt(e) {
  return e;
}
function Bt(e) {
  const [t, n] = x(!1), [o, i] = x(null), [r, a] = x({
    keepCollision: !1
  }), s = (p) => {
    a(p), e.onDebugConfigChange && e.onDebugConfigChange(p);
  }, l = !!(e.debugging && e.showDebugOptions), m = B(null), d = xe(m);
  return /* @__PURE__ */ u.createElement(Ht, { ref: m }, l ? /* @__PURE__ */ u.createElement(
    Lt,
    {
      data: o || e.clientState,
      showCamera: t,
      setShowCamera: n,
      showCollisions: r.keepCollision,
      setShowCollisions: (p) => s({
        ...r,
        keepCollision: p
      })
    }
  ) : null, /* @__PURE__ */ u.createElement(
    Ct,
    {
      isDebugging: e.debugging,
      isInteractable: l,
      showCamera: t,
      showCollisions: r.keepCollision,
      setSelected: i,
      clientState: e.clientState,
      isOverview: e.isOverview || !1,
      urlResolver: e.urlResolver || xt,
      parent: d,
      onReportMetrics: e.onReportMetrics
    }
  ));
}
const Ht = Y.div`
	min-width: 100%;
	width: 100%;
	max-width: 100%;
	min-height: 100%;
	height: 100%;
	max-height: 100%;
`;
export {
  Ut as CAMERA_TYPES,
  ne as GAME_OBJECT_TYPES,
  Bt as NavigationMap,
  Vt as applyPatches
};
//# sourceMappingURL=index.js.map
